export const themeData1 = {
  showRating: true,
  ratingBg: '#DE9356',
  showBtn: true,
  btnTextColor: '#fff',
  btnHoverTextColor: '#fff',
  btnHoverBgColor: '#000',
  btnBgColor: '#000',
  borderRadius: '0',
  borderColor: '#000000',
  addedCartText: 'Added to cart',
  addCartText: 'Add to cart',
  showSelectBox: true,
  selectBorderColor: '#B1B1B1',
  selectColor: '#000000',
  soldOutText: 'Sold Out',
  soldOutTextColor: '#fff',
  soldOutBgColor: '#FFFFFF',
  soldOutPosition: 'top-right',
  titlePorition: 'flex-start',
  bgColor: '#FFFFFF',
  TitleColor: '#000000',
  bgImgColor: '',
  productTitleColor: '#030303',
  priceColor: '#DE9356',
  originalPriceColor: '#B1B1B1',
  heightDesktopImage: '236',
  widthDesktopImage: '236',
  heightMobileImage: '236',
  widthMobileImage: '236'
};
